import { Avatar, Box, Button, Dialog, DialogContent, DialogActions, Typography, Stack, DialogTitle, SvgIcon, IconButton } from '@mui/material';
import { ReportsBuilderContext, ReportBuilderValues } from '../context/ReportsBuilderContext';
import { useContext } from 'react'; 
import { AlertTriangle } from '../../../assets'; 
import { theme } from '../../../theme';   
import CloseIcon from '@mui/icons-material/Close';

const ConfirmSave=() => {
  const { 
    openSaveReportModal, 
    handleClose,  
    handleConfirmSave, 
    canNotSaveMessage,
  } = useContext(ReportsBuilderContext) as ReportBuilderValues;

  return ( 
    <Dialog
      fullWidth
      maxWidth='sm'
      open={openSaveReportModal}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            sx={{
              backgroundColor: () => theme.palette.warning[100],
              color: () => theme.palette.warning[700],
            }}
          >
            <SvgIcon sx={{ width: '20px' }}>
              <AlertTriangle />
            </SvgIcon>
          </Avatar>
        </Box>

        <IconButton
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}>Confirm Save</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1 , whiteSpace: 'pre-line' }}
            variant="textSM">
            {canNotSaveMessage}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ 
        padding: '0px 24px 24px', 
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px', 
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          <Button
            fullWidth
            variant="secondary"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={handleClose}>
         Cancel
          </Button>
          <Button
            fullWidth
            sx={{ fontSize: '16px' }} 
            variant="primary"
            size="md"
            onClick={handleConfirmSave}
          >
          Save
          </Button>
        </Stack>
      </DialogActions>
    </Dialog > 
  );
};

export default ConfirmSave;